import clsx from "clsx";

export default function InfoCardSection({ children }) {
  return (
    <div className={cardStyle}>
      <div className="text-sm">
        {children}
      </div>
    </div>
  );
}

const cardStyle = clsx(
  "w-full h-fit lg:w-[410px] bg-white p-4 mb-2 rounded-lg shadow-md"
);
